module.exports = __webpack_public_path__ + "img/logo-office300.5e1085e0.png";